import { FleetManagementRow } from "../types/FleetManagement-row.types";
import { FleetStatus } from "../types/FleetManagement.types";

type FleetAutoPreselectionInput = {
  isEditable: boolean;
  data?: FleetManagementRow[];
  preferredVehicleInventoryId: number | null;
  autoPreselectedVehicleInventoryId: number | null;
};

type FleetAutoPreselectionResult =
  | { kind: "skip" }
  | { kind: "apply"; preferredVehicle: FleetManagementRow };

export function getFleetAutoPreselection(
  input: FleetAutoPreselectionInput
): FleetAutoPreselectionResult {
  const { isEditable, data, preferredVehicleInventoryId, autoPreselectedVehicleInventoryId } =
    input;

  if (isEditable || !data?.length || preferredVehicleInventoryId == null) {
    return { kind: "skip" };
  }

  if (autoPreselectedVehicleInventoryId === preferredVehicleInventoryId) {
    return { kind: "skip" };
  }

  const preferredVehicle = data.find(
    row => row.id === preferredVehicleInventoryId && row.status === FleetStatus.Available
  );
  if (!preferredVehicle) {
    return { kind: "skip" };
  }

  return { kind: "apply", preferredVehicle };
}
